import { DataAttributes } from './attributes';

export enum RendererSelectorType {
  ID = 'ID',
  CLASS = 'CLASS',
  ATTRIBUTE = 'ATTRIBUTE',
}

export enum RendererComponentType {
  GENERIC = 'GENERIC',
  AUTH = 'AUTH',
}

export type RendererComponent = GenericRendererComponent | RendererComponentWithAuth;

export type RendererComponentBase = {
  componentType: RendererComponentType;
  selectorType: RendererSelectorType;
  selector: string;
  component: React.FC<DataAttributes>;
};

export type GenericRendererComponent = RendererComponentBase & {
  componentType: RendererComponentType.GENERIC;
};

export type RendererComponentWithAuth = RendererComponentBase & {
  componentType: RendererComponentType.AUTH;
};
